/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Allocation_Form_Plan_Info_HintInputs */

const en_admin_allocation_form_plan_info_hint = /** @type {(inputs: Admin_Allocation_Form_Plan_Info_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you already charge for this resource via their plan, set the price to 0.`)
};

const de_admin_allocation_form_plan_info_hint = /** @type {(inputs: Admin_Allocation_Form_Plan_Info_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn du diese Ressource bereits über den Tarif abrechnest, setze den Preis auf 0.`)
};

const es_admin_allocation_form_plan_info_hint = /** @type {(inputs: Admin_Allocation_Form_Plan_Info_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si ya cobras por este recurso a través de su plan, establece el precio en 0.`)
};

const fr_admin_allocation_form_plan_info_hint = /** @type {(inputs: Admin_Allocation_Form_Plan_Info_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si vous facturez déjà cette ressource via leur plan, définissez le prix à 0.`)
};

const nl_admin_allocation_form_plan_info_hint = /** @type {(inputs: Admin_Allocation_Form_Plan_Info_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als je deze voorziening al via hun abonnement in rekening brengt, stel de prijs dan in op 0.`)
};

/** @type {(inputs: Admin_Allocation_Form_Plan_Info_HintInputs) => LocalizedString} */
const it_admin_allocation_form_plan_info_hint = en_admin_allocation_form_plan_info_hint;

/** @type {(inputs: Admin_Allocation_Form_Plan_Info_HintInputs) => LocalizedString} */
const pt_br2_admin_allocation_form_plan_info_hint = en_admin_allocation_form_plan_info_hint;

/** @type {(inputs: Admin_Allocation_Form_Plan_Info_HintInputs) => LocalizedString} */
const pl_admin_allocation_form_plan_info_hint = en_admin_allocation_form_plan_info_hint;

/** @type {(inputs: Admin_Allocation_Form_Plan_Info_HintInputs) => LocalizedString} */
const hu_admin_allocation_form_plan_info_hint = en_admin_allocation_form_plan_info_hint;

/** @type {(inputs: Admin_Allocation_Form_Plan_Info_HintInputs) => LocalizedString} */
const ro_admin_allocation_form_plan_info_hint = en_admin_allocation_form_plan_info_hint;

/**
* | output |
* | --- |
* | "If you already charge for this resource via their plan, set the price to 0." |
*
* @param {Admin_Allocation_Form_Plan_Info_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_allocation_form_plan_info_hint = /** @type {((inputs?: Admin_Allocation_Form_Plan_Info_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Allocation_Form_Plan_Info_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_allocation_form_plan_info_hint(inputs)
	if (locale === "de") return de_admin_allocation_form_plan_info_hint(inputs)
	if (locale === "es") return es_admin_allocation_form_plan_info_hint(inputs)
	if (locale === "fr") return fr_admin_allocation_form_plan_info_hint(inputs)
	if (locale === "nl") return nl_admin_allocation_form_plan_info_hint(inputs)
	if (locale === "it") return it_admin_allocation_form_plan_info_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_allocation_form_plan_info_hint(inputs)
	if (locale === "pl") return pl_admin_allocation_form_plan_info_hint(inputs)
	if (locale === "hu") return hu_admin_allocation_form_plan_info_hint(inputs)
	return ro_admin_allocation_form_plan_info_hint(inputs)
});
export { admin_allocation_form_plan_info_hint as "admin.allocation_form.plan_info_hint" }